import styled from "styled-components"
import ReactTooltip from "react-tooltip"
import TextField from "../Radiate/TextField/TextField"

export const IceBreakerContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  color: ${props => props.theme.gray7};
  font-family: sans-serif !important;
  padding: 24px 12px;
  
  h4 {
    margin: 0;
  }

  textarea {
    font-family: sans-serif !important;
  }
`

export const LeftContainer = styled.div`

`

export const RightContainer = styled.div`
  width: 600px;
  max-height: 352px;
  overflow: scroll;
  border: 1px solid #e8e7e8;
  border-radius: 8px;
  color: #707070;
  padding: 24px;
  position: relative;
  z-index: 98;
`

export const LocaleButtonContainer = styled.div`
  display: flex;
  width: 100%;
  color: ${props => props.theme.gray7};
`

export const LocaleContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledTextField = styled(TextField)`
  padding: 8px 8px;
  border-radius: 6px;
  font-size: 14px;
  border: 1px solid #e8e7e8;
  color: ${props => props.theme.gray7};

  >.content {
    border: none;
  }
`

export const InputWrapper = styled.div`
  border: 1px solid #e8e7e8;
  border-radius: 8px;
  color: #707070;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  
  

  .text-field-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 85%;
  }

  .input-button-container {
     display: flex;
     justify-content: flex-end;

    .remove-button {
      width: 34px;
      height: 34px;
      font-size: 16px;
      background: ${props => props.theme.error};
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      
      .remove-button-icon {
        color: #fff;
      }
      
    }
  }
`

export const StyledButton = styled.button`
  border: none;
  background: transparent;
  color: ${props => props.disabled ? props.theme.gray3 : "#0063f0"};
  margin-left: 12px;
  cursor: pointer;
`

export const FakeIGWrapper = styled.div`
  width: 300px;
  height: 400px;
  border-radius: 15px;
  background: white;
  box-shadow: 0px 10px 30px 10px #0000001c;
  margin: auto;
  position: relative;
  display: flex;
  flex-direction: column;
`

export const IGHeader = styled.div`
  height: 50px;
  background: white;
  border-radius: 15px 15px 0 0;
  box-shadow: 0 1px 3px 0 #8080802e;
`

export const IGBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  height: 400px;
  flex-grow: 1 
`

export const IceBreakerBubble = styled.p`
  text-align:center;
  margin-top: 0.3rem;
  border-radius: 15px;
  border: 0;
  padding: 0.5rem;
  background: #F0F0F0;
  color: #437df6;
`

export const IGFooter = styled.div`
  margin-bottom: 5px;
  margin-left: 2.5%;
  width: 95%;
  border-radius: 15px;
  border: 0;
  height: 36px;
  background: rgba(0, 0, 0, 0.02);
  display: flex;
  justify-content: space-between; 
  align-items: center;
`


export const IGINput = styled.p`
  font-size: 1rem;
  color: #BEBEBE;
  margin-left: 1rem;
`

export const IGSendButton = styled.p`
  font-size: 1rem;
  margin-right: 1rem;
  color: #437df6;
`

export const LocaleActionContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  .button-group {
    display: flex;
    .remove-button {
      width: 36px;
      height: 36px;
      font-size: 16px;
      background: ${props => props.theme.error};
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;

      .remove-button-icon {
        color: #fff;
      }

    }

    .add-button {
      margin-left: 12px;
      width: 36px;
      font-size: 16px;
      background: ${props => props.disabled ? props.theme.gray3 : "#0063f0"};
      border: 1px solid ${props => props.disabled ? props.theme.gray3 : "#0063f0"};
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;

      .add-button-icon {
        color: #fff;
      }

    }
  }
`

export const StyledTooltip = styled(ReactTooltip)`
  white-space: pre-line;
  padding: 6px 8px !important;

  &:before, &:after {
    border-width: 0px !important;
  }
`